'use strict';

/* global wc jQuery Stripe */

import PaymentElementCheckout from './modules/PaymentElementCheckout';
import PaymentElementCards from './modules/PaymentElementCards';

jQuery( ( $ ) => {
	const $elementsContainer = $( '.payment_method_element' ),
		$form = $elementsContainer.closest( 'form' );

	if ( ! $form.length ) {
		return;
	}

	if ( $form.is( '#add_payment_method' ) ) {
		new PaymentElementCards();
	} else if ( $form.is( '.checkout' ) || $form.is( '#order_review' ) ) {
		new PaymentElementCheckout();
	}
} );
